import { render, staticRenderFns } from "./CloFooterList.vue?vue&type=template&id=64ec83c6&"
import script from "./CloFooterList.vue?vue&type=script&lang=js&"
export * from "./CloFooterList.vue?vue&type=script&lang=js&"
import style0 from "./CloFooterList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports